export * from './delete-family-modal/delete-family-modal.component';
